
    import {defineComponent, onMounted, ref, watch} from 'vue';
    export  default  defineComponent({
        name:'ui-dialog',
        props:{
            isShow:{
                type:Boolean,
                default:false
            },
            title:{
                type:String,
                default:"详情"
            },
            width:{
                type:String,
                default:'50%'
            }
        },
        emits:['closeDialog','addOrEdit'],
        setup(props,ctx){
            const closeDialog = () => {
                ctx.emit('closeDialog')
            }
            const addOrEdit = () => {
                ctx.emit('addOrEdit')
            }
            onMounted(() => {

            })
            return{
                closeDialog,
                addOrEdit
            }
        }
    })
